import { max } from "d3-array";
import { scaleBand, scaleLinear } from "d3-scale";

import { colors } from "constants/tailwind";
import pluralize from "lib/pluralize";
import { BookSerializersRatingsDistribution } from "types/serializers";

const ratings = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];

export default function RatingsGraph({
  ratingsDistribution,
  rating,
}: {
  ratingsDistribution: BookSerializersRatingsDistribution[];
  rating: number;
}) {
  const roundedRating = Math.round(rating);

  const counts = ratings.map(countRating => {
    return {
      rating: countRating,
      count: ratingsDistribution
        .filter(r => r.rating === countRating)
        .reduce((i, r) => r.count + i, 0),
    };
  });

  const width = 329;
  const height = 48;
  const marginTop = 0;
  const marginRight = 0;
  const marginBottom = 5;
  const marginLeft = 0;

  // Declare the x (horizontal position) scale.
  const x = scaleBand(ratings, [marginLeft, width - marginRight]).padding(0.1);

  // Declare the y (vertical position) scale.
  const y = scaleLinear(
    [0, max(counts, d => d.count)],
    [height - marginBottom, marginTop],
  );

  // Return the SVG element.
  return (
    <div className="mt-2">
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${width} ${height}`}
        className="h-auto max-w-full"
      >
        <g>
          {counts.map(d => (
            <rect
              key={`rating-${d.rating}`}
              fill={
                d.rating === roundedRating
                  ? colors.yellow["400"]
                  : colors.gray["500"]
              }
              x={x(d.rating)}
              y={y(d.count)}
              rx="2"
              ry="2"
              height={y(0) - y(d.count) + 1}
              width={x.bandwidth()}
              data-tooltip-id="tooltip"
              data-tooltip-content={`${d.count.toLocaleString()} ${pluralize("rating", d.count)} (${d.rating} ⭐)`}
            />
          ))}
        </g>
      </svg>
    </div>
  );
}
